<template>
	<div class="v-form-public">
		<div class="form__heading" v-if="formTitle">
			<h2 class="form__title">{{formTitle}}</h2>
		</div>
		<ul class="form__list">
			<li class="form__item">
				<v-textfield-public 
					label="" 
					name="name" 
					:placeholder="contactName" 
					v-validate="`required|alpha_spaces_dash`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					label="" 
					name="phone_number" 
					type="tel"
					:placeholder="contactPhoneNumber" 
					v-validate="`required|phone_number`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					label="" 
					name="email" 
					type="email"
					:placeholder="contactEmail" 
					v-validate="`required|email`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textarea-public 
					label="" 
					name="message" 
					:placeholder="contactMessage" 
					v-validate="`required`">
				</v-textarea-public>
			</li>
			<li v-if="isRecaptcha === 'true'" class="form__item">
				<v-recaptcha @validate="checkRecaptcha" :site-key="recaptchaKey"></v-recaptcha>
			</li>
			<li v-if="buttonAlign == 'left'" class="form__item" style="justify-content: flex-start;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
			<li v-else class="form__item" style="justify-content: flex-end;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import VTextfieldPublic from "./VTextfieldPublic";
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
	inject: ['$validator'],
	components: {
		VTextfieldPublic
	},
	data () {
		return {
			recaptchaTicked: false
		}
	},
	computed: {
		...mapGetters(["locales"])
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		formTitle: {
			default: '',
			type: String
		},
		contactName: {
			default: '',
			type: String
		},
		contactPhoneNumber: {
			default: '',
			type: String
		},
		contactEmail: {
			default: '',
			type: String
		},
		contactMessage: {
			default: '',
			type: String
		},
	},
	methods: {
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			console.log(e.target);
			$(e.target).prop('disabled', true);
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						$(e.target).prop('disabled', false);
						return;
					}
				} 
				if (res) {
					let form = $('#form');
					let data = $('form').serialize();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess){
						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							success: function (result) {
								$(e.target).prop('disabled', false);
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								$(e.target).prop('disabled', false);
								if(result.responseJSON.url!==undefined){
									if(errorMessage!==''){
										sweetalert(window.app.locales.common.error,errorMessage, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}else{
										sweetalert(window.app.locales.common.error,window.app.locales.common.error, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}
								}
							}
						});
					}else{
						form.submit();
						$(e.target).prop('disabled', false);
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/js/admin/components/VContactForm.vue